export const DepositPaymentTypeOfTransferEnum = {
  CardAccountSettlement: 'CardAccountSettlement',
  OtherBankTransfer: 'OtherBankTransfer',
  OwnInsigniaAccount: 'OwnInsigniaAccount',
  OtherInsigniaAccount: 'OtherInsigniaAccount',
  BetweenInsigniaAccount: 'BetweenInsigniaAccount',
  Charge: 'Charge',
  Allocation: 'Allocation',
} as const;
export type DepositPaymentTypeOfTransferEnum = (typeof DepositPaymentTypeOfTransferEnum)[keyof typeof DepositPaymentTypeOfTransferEnum];
